// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UNb+c","header":"styles_header__+BzXc","closeIcon":"styles_closeIcon__sUQwJ","body":"styles_body__5Ie74","item":"styles_item__nuKM4"};